/**
 * The one element that scrolls pages (`Content` in `App`): the document itself never does. Browser-only, so call it from
 * an effect or an event handler, never at module scope.
 */
export function appScroller(): HTMLElement | null {
	return document.querySelector<HTMLElement>("[data-app-scroller]");
}
